/* @flow */

import React, { PureComponent } from 'react'
import type { ChildrenArray, Element } from 'react'
import type { TranslationType } from 'atpjs/helpers/i18n'

type PropsType = {
  title?: TranslationType,
  name?: TranslationType,
  children: ChildrenArray<Element<*>>,
  navigation: Element<*>
}

class Application extends PureComponent<PropsType> {
  render() {
    const { title, children, navigation = null, name } = this.props
    return (
      <section className="atp-application">
        <div className="atp-grid">
          {navigation || <div className="atp-grid-4-1 atp-hide-for-l-down" />}
          <div className="atp-grid-4-3 atp-grid-l-1-1 atp-offset-l-1-0">
            {name && <h2 className="atp-h2">{name}</h2>}
            {title && <h1 className="atp-h1">{title}</h1>}
            {children}
          </div>
        </div>
      </section>
    )
  }
}

export default Application
